import Nanobus from "nanobus";
import { AcEl } from "../helpers/html-element";
export default class AcServices {
    constructor() {
        this.services = {};
        this.events = new Nanobus();
        this.$ = AcEl;
    }
    registerService(name, service) {
        this.services[name] = service;
        return this;
    }
    getService(name) {
        return this.hasService(name) ? this.services[name] : null;
    }
    hasService(name) {
        return this.services.hasOwnProperty(name);
    }
    addListener(name, callback) {
        this.events.addListener(name, callback);
    }
    emitEvent(name, args) {
        this.events.emit(name, args);
    }
}
